/**
 * The mobile header panel.
 *
 * lib/blocks/mobile-menu.php prints a <dialog>; showModal() brings the top
 * layer, focus trapping, Escape and focus restoration with it, so this only
 * opens the right one and closes on the two gestures the browser leaves to us
 * — the same division of labour as modules/popup.js.
 *
 * The accordions inside are not handled here: the rows carry the sidebar's
 * classes, so modules/side-nav.js already drives them.
 */

import { BELOW_MENU } from './breakpoints.js';

const DIALOG = '.diakon-mobile-menu__dialog';

export function initMobileMenu() {
	const dialog = document.querySelector(DIALOG);

	if (!dialog) {
		return;
	}

	document
		.querySelector('.diakon-mobile-menu__open')
		?.addEventListener('click', () => dialog.showModal());

	dialog
		.querySelector('.diakon-mobile-menu__close')
		?.addEventListener('click', () => dialog.close());

	// The dialog itself is only ever the target on the backdrop: the inner
	// wrapper covers the card, padding included.
	dialog.addEventListener('click', (event) => {
		if (event.target === dialog) {
			dialog.close();
		}
	});

	// Widening past the breakpoint brings the real navigation back into the
	// bar. A modal left open across that would keep focus trapped in a menu
	// the visitor can no longer see, and hide the page behind a backdrop.
	const mobile = window.matchMedia(BELOW_MENU);

	mobile.addEventListener('change', () => {
		if (!mobile.matches && dialog.open) {
			dialog.close();
		}
	});
}
